module.exports = __webpack_public_path__ + "static/img/madyni.c15189c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/madyni.png
// module id = x3BJ
// module chunks = 1